/**
 * Other
 */
import React from 'react'
import { render } from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import Root from './containers/Root'
import getStore from './store'
import { tokenListener, languageListener } from './services/sessionService'
import { keyListener } from './services/sessionService'



/**
 * JS/CSS libraries imports
 */
import 'antd/dist/antd.css'
import './style/main.css'


/**
 * Main
 */
const store = getStore()

store.subscribe(() => { tokenListener(store) })
store.subscribe(() => { languageListener(store) })
store.subscribe(() => { keyListener(store) })

render(
	<Router>
		<Root store={store} />
	</Router>,
	document.getElementById('root')
)


// WEBPACK FOOTER //
// ./src/index.js